<template>
  <div class="header-search mini-width">
    <div class="w-1400 flex-b top-search">
      <!--        logo-->
      <div class="logo-word hit-cursor" @click="goHome">
        <img class="logo-big" src="../../static/index/hualianwang.png"/>
      </div>
      <!--        搜索-->
      <div class="search-box">
        <div class="search-border">
          <el-autocomplete class="inline-input" v-model="keyWords" :fetch-suggestions="getInner"
                           placeholder="请输入CAS号、中文名称、别名、英文名称" :trigger-on-focus="false" :debounce="300"
                           :popper-class="'search-suggestions'" @select="goSearch" @keyup.enter.native="goSearch()"
                           @input="onInput"
                           clearable>
            <template slot-scope="{ item }">
              <div class="suggestion-item">
                <div class="suggestion-content">
                  <span class="cas-no">{{ item.cas_no || '--' }}</span>
                  <span class="separator">|</span>
                  <span class="name">{{ item.name || '--' }}</span>
                  <span class="separator">|</span>
                  <span class="name-en">{{ item.name_en || '--' }}</span>
                </div>
              </div>
            </template>
          </el-autocomplete>
        </div>
        <div @click="goSearch()" class="search-btn">
          <i class="el-icon-search"></i>
          搜索
        </div>
      </div>
      <!--        按钮-->
      <div class="button-box">
        <div class="btn-default por" @click="goProcurement">
          <img src="../../static/index/procurement.png"/>
          我要采购
        </div>
        <div class="btn-default full" @click="goSales">
          <img src="../../static/index/sales.png"/>
          我要销售
        </div>
      </div>
      <!--        联系方式-->
      <div class="phone-work">
        <div class="service">{{ configInfo.hotline }}</div>
        <div class="little-phone">
          <span class="phone-center">
            <img src="../../static/index/phone.png"/>
            服务热线
          </span>
          <div>{{ configInfo.work_time }}</div>
        </div>
      </div>
    </div>
    <div class="w-1400">
      <div class="hot-list-search hit-cursor" v-if="showHot">
        <div class="hot-list-search-title">热门搜索:</div>
        <el-tag class="item-tag" type="danger" size="small" v-for="(item, index) in hotList" :key="index"
                @click="goSearch(item)">{{ item.label }}
        </el-tag>
      </div>
    </div>
    <Post_Inquiry :dialogVisible="showInquiry" @close="changeOrder(false)"></Post_Inquiry>
  </div>
</template>
<script>
import { getCasOptions} from "@/api/modules/common";
import Post_Inquiry from "@/components/addInfo/post_Inquiry.vue";

export default {
  name: "TopSearch",
  components: {Post_Inquiry},

  props: {
    showHot: {
      type: Boolean,
      default: false,
    },
    words: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "shop",
    },
  },
  data() {
    return {
      keyWords: "",
      showInquiry: false,
      searchTimer: null,
      isLoading: false
    };
  },
  watch: {
    words: {
      handler(newVal) {
        this.keyWords = newVal;
      },
      immediate: true,
    },
  },
  created() {
    if (this.words) {
      this.keyWords = this.words;
    }
  },
  computed: {
    configInfo() {
      return this.$store.state.config.config;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    hotList() {
      return this.$store.state.config.hotList
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 输入防抖处理
    onInput() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        // 可以在这里添加输入验证逻辑
      }, 300);
    },


    // 获取搜索建议
    async getInner(queryString, cb) {
      if (!queryString || queryString.trim().length < 1) {
        cb([]);
        return;
      }

      try {
        this.isLoading = true;
        const res = await getCasOptions({keyword: queryString.trim()});

        if (res.data && res.data.code === 10000 && res.data.data) {
          // 确保返回的数据格式正确
          let suggestions = [];
          if (Array.isArray(res.data.data)) {
            suggestions = res.data.data;
          } else if (res.data.data.data && Array.isArray(res.data.data.data)) {
            suggestions = res.data.data.data;
          } else if (res.data.data.map && Array.isArray(res.data.data.map)) {
            suggestions = res.data.data.map;
          }

          // 格式化建议数据
          const formattedSuggestions = suggestions.map(item => {
            const displayValue = item.cas_no || item.name || item.name_en || '';
            return {
              ...item,
              value: displayValue,
              label: displayValue
            };
          });

          cb(formattedSuggestions);
        } else {
          cb([]);
        }
      } catch (error) {
        console.error('获取搜索建议失败:', error);
        this.$message.error('获取搜索建议失败，请稍后重试');
        cb([]);
      } finally {
        this.isLoading = false;
      }
    },
    changeOrder(e) {
      this.showInquiry = e
    },

    // 跳转到首页
    goHome() {
      this.$router.push("/");
    },

    async init() {
      if (this.showHot) {
        this.$store.dispatch('getHotList')
      }
    },
    goSearch(item) {
      let currentPath = this.$route.path;

      // 处理搜索关键词
      if (item && typeof item === 'object') {
        this.keyWords = item.label || item.value || item.cas_no || item.name || '';
      } else if (item && typeof item === 'string') {
        this.keyWords = item;
      }

      // 验证搜索内容
      if (!this.keyWords || this.keyWords.trim().length === 0) {
        this.$message.warning({
          message: "请输入搜索内容",
          center: true,
          offset: 300,
        });
        return;
      }

      // 根据类型处理搜索
      if (this.type == "shop") {
        console.log("搜索关键词:", this.keyWords);
        this.$emit("getList", this.keyWords.trim());
        return;
      }

      // 处理页面跳转
      if (currentPath != "/search-page") {
        this.$router.push("/search-page?keyWords=" + encodeURIComponent(this.keyWords.trim()));
      } else {
        this.$emit("search", this.keyWords.trim());
      }
    },

    goProcurement() {
      if (this.isLogin) {
        if (this.mixCheckUserAudit()) {
          this.showInquiry = true
        } else {
          this.showInquiry = false
        }
      } else {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        }).catch(() => {
          // 用户取消登录
        });
      }
    },

    goSales() {
      if (this.isLogin) {
        if (this.mixCheckUserAudit()) {
          this.$router.push("/user/supplier/my-project");
        }
      } else {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        }).catch(() => {
          // 用户取消登录
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.hot-list-search-title {
  color: #757575;
}

.top-search {
  align-items: center;
}

.header-search {
  height: 120px;
  background: #ffffff;
  box-shadow: 0px 3px 12px 1px rgba(25, 25, 70, 0.06);
  padding: 20px 0 0;
  box-sizing: border-box;
  width: 100%;
  position: relative;
  z-index: 99;

  .logo-word {
    display: flex;
    color: #000000;
    align-items: center;

    .logo-big {
      width: 180px;
      margin-right: 20px;
      height: 62px;
      object-fit: contain;
    }
  }

  .hot-list-search {
    display: flex;
    margin-left: 214px;
    align-items: center;
    flex-wrap: wrap;

    .item-tag {
      margin-left: 10px;
      margin-bottom: 5px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .search-box {
    display: flex;
    box-sizing: border-box;
    position: relative;

    .search-border {
      width: 445px;
      height: 45px;
      background: #ffffff;
      border: 1px solid #e0e0e0;
      border-radius: 6px 0 0 6px;
      line-height: 45px;
      // padding: 0 15px;
      transition: border-color 0.3s ease;

      &:focus-within {
        border-color: #4b87ff;
        box-shadow: 0 0 0 2px rgba(75, 135, 255, 0.1);
      }

      .inline-input {
        width: 100%;

        ::v-deep .el-input__inner {
          border: none;
          font-size: 16px;
          color: #757575;
          height: 43px;
          line-height: 43px;

          &:focus {
            outline: none;
            box-shadow: none;
          }
        }
      }
    }

    .search-btn {
      width: 132px;
      height: 45px;
      background: #4b87ff;
      border-radius: 0px 6px 6px 0px;
      border: 1px solid #0c60e6;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 45px;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        margin-right: 5px;
        font-size: 16px;
      }

      &:hover {
        background: #3a7ce8;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(75, 135, 255, 0.3);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  .button-box {
    display: flex;
    margin-left: 20px;
    box-sizing: border-box;

    .btn-default {
      width: 194px;
      height: 45px;
      border-radius: 6px;
      text-align: center;
      line-height: 45px;
      font-weight: bold;
      font-size: 20px;
      cursor: pointer;
      transition: all 0.3s ease;

      img {
        margin-right: 18px;
        vertical-align: middle;
      }

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }

    .por {
      border: 2px solid #4b87ff;
      color: #4b87ff;

      img {
        width: 26.83px;
        height: 20.76px;
      }

      &:hover {
        background: #4b87ff;
        color: #ffffff;
      }
    }
  }

  .full {
    margin-left: 21px;
    background: #4b87ff;
    color: #ffffff;
    border: 1px solid #0c60e6;

    img {
      width: 17.86px;
      height: 19.82px;
    }

    &:hover {
      background: #3a7ce8;
    }
  }

  .phone-work {
    margin-left: 20px;
    text-align: center;
    width: 125px;

    .service {
      font-weight: bold;
      color: #ff4400;
      font-size: 18px;
      white-space: nowrap;
    }

    .little-phone {
      font-weight: 400;
      font-size: 10px;
      color: #afafaf;

      .phone-center {
        img {
          width: 24px;
          height: 23px;
          vertical-align: middle;
        }
      }
    }
  }
}

// 搜索建议样式
::v-deep .search-suggestions {
  min-width: 580px !important;
  max-width: 600px !important;

  .suggestion-item {
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #f8f9fa;
    }

    &:last-child {
      border-bottom: none;
    }

    .suggestion-content {
      display: flex;
      align-items: center;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex-wrap: nowrap;
      gap: 8px;

      .cas-no {
        font-weight: 600;
        color: #2c3e50;
        font-size: 14px;
        min-width: 80px;
        flex-shrink: 0;
      }

      .separator {
        color: #ddd;
        font-size: 12px;
        flex-shrink: 0;
      }

      .name {
        color: #333;
        font-size: 14px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .name-en {
        color: #666;
        font-size: 13px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .el-autocomplete-suggestion__list {
    max-height: 350px;
    padding: 0;
  }

  .el-autocomplete-suggestion__list li {
    padding: 0;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>
